export enum NotificationIntent {
  Info = "info",
  Success = "success",
  Warning = "warning",
  Error = "error",
}
